function extractHostname(url) {
  if (!url) {
    return undefined
  }

  const parts = url.split('//'),
    [noPort] = parts[parts.length - 1].split(':'),
    [noParam] = noPort.split('?'),
    [hostname] = noParam.split('/')

  return hostname
}

export { extractHostname }
